/**
 * conClearfile
 */
import 'intersection-observer';
import {gsap, Expo, Elastic} from 'gsap'

export default class conClearfile {

  constructor() {
    // クラス名
    this.id = 'p-clearfile';
    this.el = document.getElementById(this.id);

    if (this.el) {
      this.init();
    }
  }

  init() {
    this.elParents = [
      'p-clearfile',
      'p-clearfile__wrap',
      'p-clearfile__wrapAppli',
    ];
    this.isStartedCount = 0;
    this.isCompletedCount = 0;
    this.max = this.elParents.length;//this.elを含める
    this.timelines = {};

    // アニメーションするDOM
    this.containers = {};

    this.elParents.forEach((id, i) => {
      const parent = document.getElementById(id);
      this.containers[id] = {
        parent: parent
      };

      // gsap timeline
      this.initTimeline(id, parent);
    });

    // イベント
    const options = {
      root: null,
      rootMargin: '-30% 0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver(this.intersect.bind(this), options);
    for (let key in this.containers) {
      this.observer.observe(this.containers[key].parent);
    }
  }

  initTimeline(id, parent) {
   this.timelines[id] = gsap.timeline({
      paused: true,
      onComplete: this.timelineComp.bind(this, [id]),
    });
    const tl = this.timelines[id];

    tl.addLabel('start', 0);
    tl.set(parent, {visibility: 'visible'}, 'start');

    if (id === 'p-clearfile') {
      tl.fromTo(parent.querySelector('.p-clearfile__title img'), {
        opacity: 0,
        y: '20%',
      }, {
        duration: 1.4,
        opacity: 1,
        y: '0%',
        ease: Expo.easeOut
      }, 'start+=0.1');

      tl.fromTo(parent.querySelector('.p-clearfile__cloud1'), {
        opacity: 0,
        y: '10%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Expo.easeOut
      }, 'start+=0.2');

      tl.fromTo(parent.querySelector('.p-clearfile__cloud2'), {
        opacity: 0,
        y: '10%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Expo.easeOut
      }, 'start+=0.3');

      tl.fromTo(parent.querySelector('.p-clearfile__cloud3'), {
        opacity: 0,
        y: '10%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Expo.easeOut
      }, 'start+=0.4');
    } else if (id === 'p-clearfile__wrap') {
      tl.fromTo(parent.querySelector('.p-clearfile__wrapTitle'), {
        opacity: 0,
        y: '10%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Expo.easeOut
      }, 'start+=0.1');

      tl.fromTo(parent.querySelector('.p-clearfile__wrapItems'), {
        opacity: 0,
        y: '10%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Expo.easeOut
      }, 'start+=0.1');
    } else if (id === 'p-clearfile__wrapAppli') {
      tl.fromTo(parent, {
        opacity: 0,
        y: 100,
      }, {
        duration: 1.0,
        opacity: 1,
        y: 0,
        ease: Expo.easeOut
      }, 'start+=0.1');
    }
  }

  timelineComp(e) {
    this.isCompletedCount++;
    const id = e[0];

    this.timelines[id].clear();
    delete this.timelines[id];

    if (this.isCompletedCount === this.max) {
      delete this.containers;
      delete this.timelines;
    }
  }

  intersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting === true) {
        // 表示スタート
        requestAnimationFrame(this.start.bind(this, [entry.target.id]));
        this.observer.unobserve(entry.target);
      }
    });
  }

  start(e) {
    this.isStartedCount++;
    const id = e[0];

    this.timelines[id].play(0);

    if (this.isStartedCount === this.max) {
      this.clearIntersect();
    }
  }

  clearIntersect() {
    this.observer.disconnect();
    delete this.observer;
  }
}
